import { z } from 'zod';

/**
 * Schema de validación para Checkout
 */

const checkoutPaymentMethodSchema = z.enum(['cash', 'card', 'yape', 'wallet'], {
  required_error: 'Debes seleccionar un método de pago',
  invalid_type_error: 'Método de pago inválido',
});

export const checkoutSchema = z.object({
  paymentMethod: checkoutPaymentMethodSchema,
  cashAmount: z
    .number({
      invalid_type_error: 'El monto debe ser un número',
    })
    .positive('El monto debe ser mayor a 0')
    .optional(),
  total: z
    .number()
    .positive('El total debe ser mayor a 0')
    .optional(), // Opcional porque se calcula dinámicamente
  tableNumber: z
    .string()
    .max(10, 'El número de mesa no puede exceder 10 caracteres')
    .optional(),
  waiterName: z
    .string()
    .max(100, 'El nombre del mesero no puede exceder 100 caracteres')
    .optional(),
  customerName: z
    .string()
    .max(200, 'El nombre del cliente no puede exceder 200 caracteres')
    .optional(),
  customerPhone: z
    .string()
    .max(20, 'El teléfono del cliente no puede exceder 20 caracteres')
    .optional(),
}).refine(
  (data) => {
    // Si es pago en efectivo, cashAmount es requerido y debe ser >= total (si total existe)
    if (data.paymentMethod === 'cash' && data.total !== undefined) {
      return data.cashAmount !== undefined && data.cashAmount >= data.total;
    }
    return true;
  },
  {
    message: 'El monto recibido debe ser mayor o igual al total a pagar',
    path: ['cashAmount'], // El error aparecerá en el campo cashAmount
  }
);

export type CheckoutFormData = z.infer<typeof checkoutSchema>;
